export default "__VITE_PUBLIC_ASSET__8e5be927__"